<template>
  <v-container wrap>
    <v-card class="pa-3">
      <div v-if="loading">
        <circles-loader></circles-loader>
      </div>
      <div v-else-if="valid">
        <h1>{{ academy.name }}</h1>
        <h3>{{ academy.address }}
          <country-display :country-code="academy.city.country" />
        </h3>
        <v-btn absolute fab top left color="white" style="margin-top: 20px">
          <v-avatar v-if="$store.state.academyImage" size="45px" absolute top left>
            <img :src="userFile(this.$store.state.academyImage)" alt="avatar">
          </v-avatar>
        </v-btn>
        <v-btn absolute dark fab top right color="pink" style="margin-top: 20px" @click="launchWaiver">
          <v-icon>assignment</v-icon>
        </v-btn>
        <v-layout row>
          <v-flex justify-center style="margin-top:5px">
            <div class="text-xs-center">
              <v-select :items="availableClasses" :label="$t('message.select_class')" item-text="className"
                item-value="className" v-model="selectedClass" @change="selectClass(item)" solo></v-select>
              <div class="text-center code-display">
                {{ checkinCode }}
              </div>
              <v-container grid-list-md v-if="academy">
                <v-layout row wrap>
                  <v-flex xs1>
                    <v-btn class="mx-2" fab dark color="secondary" @click="clickNumber(1)">
                      1
                    </v-btn>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn class="mx-2" fab dark color="secondary" @click="clickNumber(2)">
                      2
                    </v-btn>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn class="mx-2" fab dark color="secondary" @click="clickNumber(3)">
                      3
                    </v-btn>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn class="mx-2" fab dark color="secondary" @click="clickNumber(4)">
                      4
                    </v-btn>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn class="mx-2" fab dark color="secondary" @click="clickNumber(5)">
                      5
                    </v-btn>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn class="mx-2" fab dark color="secondary" @click="clickNumber(6)">
                      6
                    </v-btn>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn class="mx-2" fab dark color="secondary" @click="clickNumber(7)">
                      7
                    </v-btn>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn class="mx-2" fab dark color="secondary" @click="clickNumber(8)">
                      8
                    </v-btn>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn class="mx-2" fab dark color="secondary" @click="clickNumber(9)">
                      9
                    </v-btn>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn class="mx-2" fab dark color="secondary" @click="clickNumber(0)">
                      0
                    </v-btn>
                  </v-flex>
                  <v-flex xs1>
                    <v-btn class="mx-2" fab dark color="secondary" @click="clickNumber(-1)">
                      <v-icon>backspace</v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
              <v-btn outlined color="primary" :disabled="validNumber ? false : true" @click="checkin()">CHECKIN
              </v-btn>
            </div>
            <div style="margin-top: 10px">
              <v-card>
                <last-checkin :user="checkedInUser" :members-only="true" />
              </v-card>
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div v-else>
        <p class="no-academy">{{ $t('message.no_academy_selected') }}</p>
      </div>
    </v-card>
    <v-footer color="none" app inset>
      <v-btn icon text small @click="logout()" v-if="$store.state.isUserLoggedIn">
        <v-icon>exit_to_app</v-icon>
      </v-btn>
    </v-footer>
  </v-container>
</template>

<script>
import Api from '@/services/Api';
import CirclesLoader from "@/components/displays/CirclesLoader.vue";
import CountryDisplay from '@/components/displays/CountryFlagDisplay.vue';
import LastCheckin from '@/components/displays/LastCheckinDisplay.vue';

export default {
  data() {
    return {
      mask: '##-##-##',
      checkinCode: '',
      validNumber: false,
      loading: true,
      valid: false,
      availableClasses: null,
      selectedAcademy: this.$store.state.selectedAcademy,
      selectedClass: '',
      selectedClassStart: null,
      academy: null,
      checkedInUser: null
    };
  },
  components: {
    CirclesLoader,
    CountryDisplay,
    LastCheckin
  },
  created() {
    if (!this.$store.state.selectedAcademy) {
      this.navigateTo({ name: 'pickacademy' })
    }
    Api().get('admins/academy/' + this.selectedAcademy)
      .then(response => {
        this.loading = false;
        const data = response.data;
        if (data) {
          this.academy = data;
          this.checkValidity();
        }
      });
    this.loadClasses();
  },
  watch: {
    checkinCode: {
      immediate: true,
      handler: function () {
        this.checkCodeValidity()
      }
    }
  },
  methods: {
    clickNumber(num) {
      if (num < 0) {
        if (this.checkinCode.length > 0) {
          //deleting
          this.checkinCode = this.checkinCode.substring(0, this.checkinCode.length - 1);
        }
      } else {
        if (this.checkinCode.length < 6)
          this.checkinCode += num + '';
      }
    },
    selectClass(item) {
      for (const c of this.availableClasses) {
        if (c.className == item)
          this.selectedClassStart = c.startTime;
      }
    },
    loadClasses() {
      Api().get('academies/classes/' + this.selectedAcademy)
        .then(response => {
          this.availableClasses = response.data;
          if (this.availableClasses.length == 1) {
            this.selectedClass = this.availableClasses[0].className;
            this.selectedClassStart = this.availableClasses[0].startTime;
          }
        });
    },
    launchWaiver() {
      this.navigateTo({ name: 'waiver' });
    },
    checkCodeValidity() {
      if (this.checkinCode && this.checkinCode.length == 6)
        this.validNumber = true;
      else
        this.validNumber = false;
    },
    checkValidity() {
      if (this.selectedAcademy) {
        this.valid = true;
      }
    },
    logout() {
      this.$store.dispatch("setToken", null);
      this.$store.dispatch("setUser", null);
      localStorage.removeItem("token");
      window.location.replace('/login?specialroute=checkin');
    },
    checkin() {
      const date = new Date();
      const postData = {
        date: date.toString(),
        day: this.getDayString(date),
        academyId: this.$store.state.selectedAcademy,
        className: this.selectedClass,
        startTime: this.selectedClassStart
      };
      //var code = this.checkinCode.replace(/-/g,'');
      var code = this.checkinCode;
      this.checkedInUser = null;
      Api().post('admins/academy/' + this.$store.state.selectedAcademy + '/checkin/' + code, postData)
        .then(response => {
          const data = response.data;
          if (data) {
            try {
              this.checkinCode = '';
              this.loadClasses();
              this.checkedInUser = {
                fName: data.member.fName,
                lname: data.member.lName,
                belt: data.member.belt,
                userImage: data.member.userImage,
                countryCode: data.member.nationality,
                daysAtBelt: data.daysAtBelt,
                classesAtBelt: data.classesAtBelt,
                member: true
              };
            } catch (e) {
              console.log(e);
            }
          }
        })
        .catch(e => {
          if (e)
            this.showAlert("error", "Oops!", this.$t('message.error_generic'));
        })
    }
  }
};
</script>

<style scoped>
.no-academy {
  font-size: 2em;
  color: red;
}

.code-display {
  font-size: 3em;
  text-align: center;
  width: 100%;
  height: 60px
}
</style>